import type { PostgrestError } from '@supabase/supabase-js';
import { supabase } from '@/shared/supabase/client';
import { COMPARTIMENT, DUREE_ADRESSE_SECONDES } from './chemins';
import { messageErreur } from './lignes';

function compartiment() {
  return supabase().storage.from(COMPARTIMENT);
}

/**
 * Dépose le fichier, puis enregistre sa ligne. Si la ligne est refusée, le
 * fichier est retiré : pas d'objet orphelin que personne ne verrait jamais.
 */
export async function deposerPuisEnregistrer(
  chemin: string,
  fichier: File,
  enregistrer: () => PromiseLike<{ error: PostgrestError | null }>
): Promise<void> {
  const depot = await compartiment().upload(chemin, fichier, {
    contentType: fichier.type || 'application/octet-stream',
    upsert: false,
  });
  if (depot.error) throw new Error('Le fichier n’a pas pu être envoyé.');

  const { error } = await enregistrer();
  if (error) {
    await compartiment().remove([chemin]);
    throw new Error(messageErreur(error, 'Le document n’a pas pu être enregistré.'));
  }
}

/**
 * Retire des fichiers dont la ligne est déjà supprimée. Un échec ici laisse un
 * objet orphelin mais ne ment pas à l'écran : le document, lui, n'existe plus.
 */
export async function retirerFichiers(chemins: readonly string[]): Promise<void> {
  if (chemins.length === 0) return;
  await compartiment().remove([...chemins]);
}

/** Une adresse signée, valable dix minutes. */
export async function adresseSignee(chemin: string): Promise<string> {
  const { data, error } = await compartiment().createSignedUrl(chemin, DUREE_ADRESSE_SECONDES);
  if (error) throw new Error('Le document n’a pas pu être ouvert.');
  return data.signedUrl;
}
